import {
  required,
  TextInput,
  minLength,
  maxLength,
  email,
  SelectInput,
  ReferenceInput,
  AutocompleteInput,
  BooleanInput,
  Labeled,
  regex,
} from "react-admin";

import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import { GenderOptionsId } from "utils/choices";
import { settings } from "app";
import { useState } from "react";
import { administrationRequests } from "api/administrationApi";
import PreferenceSection from "./PreferenceSection";
import UserSearchInput from "./UserSearchInput";

const PersonalInfo = ({
  discount,
  setDiscount,
  isForeigner,
  formData,
  laureatesData,
  laureateChoiceIds,
  setLaureateChoiceIds,
}) => {
  const [isUserSearched, setIsUserSearched] = useState(false);

  const handleLaureateChange = id => {
    if (laureateChoiceIds.includes(id)) {
      setLaureateChoiceIds(laureateChoiceIds.filter(x => x !== id));
    } else {
      setLaureateChoiceIds([...laureateChoiceIds, id]);
    }
  };

  return (
    <>
      <UserSearchInput
        isForeigner={isForeigner}
        onSearched={setIsUserSearched}
      />

      {isUserSearched && (
        <>
          <Grid
            container
            spacing={4}
            sx={settings.style.gridContainer}
          >
            <Grid
              item
              xs={12}
              md={4}
            >
              <TextInput
                label="Име"
                source="info.firstName"
                validate={[required(), minLength(2), maxLength(30)]}
                fullWidth
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <TextInput
                label="Презиме"
                source="info.secondName"
                validate={[minLength(2), maxLength(30)]}
                fullWidth
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <TextInput
                label="Фамилия"
                source="info.lastName"
                validate={[required(), minLength(2), maxLength(30)]}
                fullWidth
              />
            </Grid>
            {isForeigner && (
              <>
                <Grid
                  item
                  xs={12}
                  md={4}
                >
                  <TextInput
                    label="Име (латиница)"
                    source="info.firstNameEn"
                    validate={[required(), minLength(2), maxLength(30)]}
                    fullWidth
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                >
                  <TextInput
                    label="Презиме (латиница)"
                    source="info.secondNameEn"
                    validate={[minLength(2), maxLength(30)]}
                    fullWidth
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                >
                  <TextInput
                    label="Фамилия (латиница)"
                    source="info.lastNameEn"
                    validate={[required(), minLength(2), maxLength(30)]}
                    fullWidth
                  />
                </Grid>
              </>
            )}
            {!isForeigner && (
              <Grid
                item
                xs={12}
                md={4}
              >
                <TextInput
                  label="Имейл"
                  source="email"
                  validate={[required(), email()]}
                  fullWidth
                />
              </Grid>
            )}

            {!isForeigner && (
              <Grid
                item
                xs={12}
                md={4}
              >
                <TextInput
                  label="Телефон"
                  source="info.contactPhone"
                  validate={[required(), regex(/^(359|0){1}[0-9]{9}$/, "Моля въведете валиден телефон")]}
                  fullWidth
                />
              </Grid>
            )}
            <Grid
              item
              xs={12}
              md={4}
            >
              <SelectInput
                label="Пол"
                source="info.gender"
                choices={GenderOptionsId}
                validate={[required()]}
                fullWidth
              />
            </Grid>

            {isForeigner && (
              <Grid
                item
                xs={12}
                md={4}
              >
                <ReferenceInput
                  source="info.residenceCountryId"
                  reference={administrationRequests.getCountriesSelect()}
                >
                  <AutocompleteInput
                    validate={[required()]}
                    label="Държава"
                    optionText="nameBg"
                    optionValue="id"
                    filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                  />
                </ReferenceInput>
              </Grid>
            )}

            {!isForeigner && (
              <>
                <Grid
                  item
                  xs={12}
                >
                  <BooleanInput
                    label={
                      "Лауреат ли сте на Национална олимпиада за текущата година по химия или биология с оценка отличен 6?"
                    }
                    source={"isLaureate"}
                    onChange={() => (!formData.isLaureate ? setLaureateChoiceIds([]) : null)}
                    defaultValue={false}
                  />
                </Grid>
                {formData.isLaureate &&
                  laureatesData?.map((item, index) => {
                    return (
                      <Grid
                        key={index}
                        item
                        xs={12}
                        md={6}
                      >
                        <Labeled
                          label={item.name}
                          sx={{
                            textAlign: "left",
                            gridColumn: "span 2",
                          }}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={laureateChoiceIds.includes(item.id)}
                                onChange={() => handleLaureateChange(item.id)}
                              />
                            }
                            label={` ${item.name}`}
                          />
                        </Labeled>
                      </Grid>
                    );
                  })}

                <Grid
                  container
                  spacing={2}
                >
                  <Grid
                    item
                    xs={12}
                  >
                    <PreferenceSection
                      formData={formData}
                      discount={discount}
                      setDiscount={setDiscount}
                    />
                  </Grid>
                </Grid>
              </>
            )}
          </Grid>
        </>
      )}
    </>
  );
};

export default PersonalInfo;
